import React from "react";
import "../styles/Contact.css";
import ContactHeroSection from "../content/contactData/contactHeroSection/ContactHeroSection";
import ContactSocialSection from "../content/contactData/socailMediaLinks/ContactSocialSection";
import ContactFormCTASection from "../content/contactData/contactFormCTASection/ContactFormCTASection";

function Contact() {
  return (
    <>
      <ContactFormCTASection />
      <ContactHeroSection />
      <ContactSocialSection />
    </>
  );
}

export default Contact;
